import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { VxeSelect } from 'vxe-pc-ui';
import { onMounted, ref } from 'vue';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-u-dict-name-select',
  setup(__props, {
    expose: __expose
  }) {
    const {
      loading,
      runAsync: getCateListApi
    } = fetchApi('common.uDictionary.getCateList');
    const cateList = ref([]);
    const loadCateList = async () => {
      const {
        error,
        rows
      } = await getCateListApi({});
      if (error) return;
      cateList.value = rows.map(item => {
        const {
          id,
          name
        } = item;
        return {
          value: id,
          label: name
        };
      });
    };
    onMounted(() => {
      loadCateList();
    });
    __expose({
      refresh() {
        return loadCateList();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(VxeSelect), _mergeProps({
        loading: _unref(loading),
        options: cateList.value
      }, _ctx.$attrs), null, 16, ["loading", "options"]);
    };
  }
};